import React, { Fragment } from 'react';
import { Spin, Image, Typography, Button, Row, Col, Card, Form, Input, Select, Radio, DatePicker, Collapse, Tooltip, Carousel, Badge } from 'antd';
import { createLead } from '../../api/pets-api';
import { Link } from "react-router-dom";
import moment from 'moment';
import { CURRENCY, BenifitsMap } from '../../constants';
import { notifications } from '../../helpers/utilities';
import FeaturesTable from './features_table';
// import { faqHomePageItems } from '../../helpers/faqHomePageList';
import curablepreexistingconditionspdf from '../../assets/images/curable-preexisting-conditions-coverage-after-12-months.pdf';
const { Paragraph, Title } = Typography;
const { Panel } = Collapse;

const { Option } = Select;

class MainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            petTypeBreeds: [],
            petBreeds: [],
            plans: [],
            spin: true,
            disableBtn: false,
            dogId: '',
            type: 'Cat',
            genderBtnType: 'Male',
            petBtnType: 'Cat',
            petBtnClass: 'Cat',
            faqItems:[]
        }
        this.changeType = this.changeType.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.onFinishFailed = this.onFinishFailed.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        // this.saveQoute = this.saveQoute.bind(this);
    }
    qouteRef = React.createRef()
    formRef = React.createRef();
    pageRef = React.createRef();
    mainRef = React.createRef();

    onGenderChange = (e) => {
        // console.log('change', e.target.value);
        this.setState({ genderBtnType: e.target.value })
    }
    onTypeChange = (e) => {
        // console.log('change', e.target.value);
        this.setState({ petBtnType: e.target.value })
        if (e.target.value === this.state.dogId) {
            this.setState({ petBtnClass: 'dog' })
        }else{
            this.setState({ petBtnClass: 'cat' })
        }
    }

    onDetailClick = () => {
        this.pageRef.current.scrollIntoView();
    }

    componentDidMount = () => {
        console.log('props child', this.props);
        
        
        this.props.setQouteRef(this.qouteRef)
        this.mainRef.current.scrollIntoView()
        // console.log('mount', this.props.petTypeBreeds);
        this.props.petTypeBreeds.map(type => {
            if (type.name == 'Cat') {
                this.setState({ dogId: type.id, petBreeds: type.breeds })
            }
        });
        this.setState({ petTypeBreeds: this.props.petTypeBreeds, plans: this.props.plans }, ()=>{
            
            if(this.props.location.pathname === "/ins"){
                this.goToQouteSection()
            }
        });

        const faqHomePageItems = [
            {
                question: "Can I visit any veterinarian? ( with my cat or my dog )",
                answer: "Of course ! We understand the importance of a trusting relationship between you and the vet. If you purchased your plan with OSLO, you may visit any licensed veterinarian in the UAE. This includes specialists and emergency.",
                hasChildItems: false
            },
            {
                question: "What is an annual deductible for pet insurance?",
                answer: "An annual deductible is the fixed amount per policy period (one year) that needs to be met before we would begin to pay benefits for covered claims, at the elected reimbursement amount. Only covered claims will be applied to your annual deductible. Your deductible will reset when your policy renews each year.",
                hasChildItems: false
            },
            {
                question: "What is a co-insurance for pet insurance?",
                answer: "Co-insurance is the percentage of the vet bill the pet parent is responsible for versus what OSLO will pay . With Oslo you have the option to choose between 70%, 80%, 90% . Keep in mind that this is applied to every claim.",
                hasChildItems: false
            },
            {
                question: "When does my policy start?",
                answer: "Oslo policies are effective at 12:01am standard time at your mailing address the day after enrollment.",
                hasChildItems: false
            },
            {
                question: "How do I file a claim? for my dog or cat",
                answer: "Electronic/Paperless Claims Submission",
                hasChildItems: true,
                childItems: [
                    {
                        text: "Log into your Oslo Pet Cloud from any device."
                    },
                    {
                        text: "Select the “Send a claim” card and answer the online questions."
                    },
                    {
                        text: "Upload/attach a copy of your paid invoice and submit your claim."
                    },
                    {
                        text: "Have your veterinarian send us your pet’s medical records."
                    },
                    {
                        text: "You’re done!"
                    }
                ]
            },
            {
                question: "Can I pay on a monthly basis? ",
                answer: "Oslo is working with TAMARA where you can pay up to 4 installments. You will have the choice between annual premium or installment",
                hasChildItems: false
            },
            {
                question: "Can I get a sample of the insurance policy? (dog or cat)",
                answer: "Yes sure at OSLO we are fully transparent. you can download our policy summary from our website.",
                hasChildItems: false
            },
            {
                question: "How do I add another pet?",
                answer: "Each pet needs its own policy and you will have to set each policy one at a time. If you’re buying the policies during your first purchase, please select “add a pet”. If you wish to purchase another policy after having purchased a policy for your first pet, just login to your Oslo Pet Cloud and hit “add a pet” in your account to get a new quote for your other furry friend – and get a 5% multi-pet discount!",
                hasChildItems: false
            },
            {
                question: "Curable Pre-Existing Conditions (Coverage After 12 Months)",
                answer: "A curable pre-existing condition is a short-term illness or injury your pet had before you purchased the policy, but which can be fully resolved with treatment and has not shown any symptoms or required treatment for at least 12 consecutive months. Examples of conditions that will not be covered:",
                hasChildItems: true,
                childItems: [
                    {
                        text: "Diabetes or Hyperthyroidism"
                    },
                    {
                        text: "Chronic Ear Infections"
                    },
                    {
                        text: "Intervertebral Disc Disease"
                    },
                    {
                        text: "Allergies or Atopic Dermatitis"
                    },
                    {
                        text: "Hip Dysplasia"
                    }
                ]
            }
        ];

        this.setState({faqItems: faqHomePageItems});
    }

    componentDidUpdate(prevProps) {

        if (this.props.petTypeBreeds !== prevProps.petTypeBreeds) {
            if (this.state.spin) {
                console.log('update', this.props.petTypeBreeds);

                this.props.petTypeBreeds.map(type => {
                    if (type.name == 'Cat') {
                        this.setState({ dogId: type.id, petBreeds: type.Breads })
                    }
                })
                this.setState({ spin: false })
            }
            let typeBreeds = this.props.petTypeBreeds;
            typeBreeds.map(type => {
                let crossIndex = type.Breads.findIndex(breed => breed.name === 'Crossbreed');
                if (crossIndex !== -1) {
                    type.Breads.unshift(type.Breads.splice(crossIndex, 1)[0]);
                }
            })
            this.setState({ petTypeBreeds: typeBreeds })
        }
        if (this.props.plans !== prevProps.plans) {
            console.log('plans', this.props.plans);

            this.setState({ plans: this.props.plans });
        }
    }

    async onFinish(values) {

        let isPrimaryPet = this.props.addNewPet ? false : true;

        let selectedDate = values.age;
        let type = this.state.type;
        let ageMthDiff = Math.floor(moment().diff(selectedDate, 'months', true));
        let ageYrDiff = Math.floor(moment().diff(selectedDate, 'years', true));
        console.log('age different params', ageMthDiff, ageYrDiff, type);
         if (ageMthDiff > 96 && type === 'Dog') {
            let ageMsg = 'Oops, Oslo does not start new cover above 8 years old, please contact us at support@osloinsurance.pet for more info'
            notifications(ageMsg, 'Alert', 'error')
            this.setState({ disableBtn: true });
            return;
        } else if (ageMthDiff > 120 && type === 'Cat') {
            let ageMsg = 'Oups, Oslo does not start new cover above 10 years old, please contact us at support@osloinsurance.pet for more info'
            notifications(ageMsg, 'Alert', 'error')
            this.setState({ disableBtn: true });
            return;
        }

        console.log('cleicked')
        values = { ...values, age: moment(values.age).toDate(), isPrimaryPet: isPrimaryPet }
        console.log(values);
        let pPlanObj = {}
        pPlanObj = this.props.preQoute.hasOwnProperty('petsWithPlans') ? { petsWithPlans: this.props.preQoute.petsWithPlans } : { petsWithPlans: [] }
        pPlanObj.petsWithPlans.splice(pPlanObj.petsWithPlans.length, 0, { ...values, planId: 1, reimburseId: 1, deductionId: 1 });
        console.log('pPlanObj',pPlanObj);
        var respLead = await createLead(pPlanObj);

        let localStorageQuote = {
            currency: 'AED',
            email: values.email,
            pets:[
                {
                    name: values.name,
                    petTypeId: values.type,
                    breedId: values.breed,
                    dob: moment(values.age).format('YYYY-MM-DD'),
                    gender: values.gender
                }
            ]
        }

        localStorage.setItem('osloQuoteData', JSON.stringify(localStorageQuote));



        if(respLead.data.error){
            notifications('Error occored while saving the lead', 'Alert', 'error')
        }else{
            
            this.props.setLeadId(respLead.data.result);
            localStorage.setItem('lead', respLead.data.result);
        }
        this.props.populateQoute(pPlanObj)
        this.props.changeFlag('qoute')

        // Navigate to the quotation page
        if (this.props.history) {
            this.props.history.push('/quotation');
        } else {
            // Fallback if history is not available
            window.location.href = '/quotation';
        }
    };

    onFinishFailed(errorInfo) {
        console.log('Failed:', errorInfo);
    };

    changeType(event) {
        let index = event.target.id;
        let type = event.target.petType;
        let petBreeds = this.state.petTypeBreeds[index].Breads
        this.setState({ petBreeds, type })
    }

    goToQouteSection = () => {
        this.qouteRef.current.scrollIntoView()
    }

    ageChange = () => {
        this.setState({ disableBtn: false }, () => {

            let selectedDate = this.formRef.current.getFieldValue('age');
            let type = this.state.type;
            let ageMthDiff = Math.floor(moment().diff(selectedDate, 'months', true));
            let ageYrDiff = Math.floor(moment().diff(selectedDate, 'years', true));
            console.log('age different params', ageMthDiff, ageYrDiff, type);
            if (ageMthDiff < 2) {
                let dateCopy = moment(selectedDate);
                let nextDate = dateCopy.add(2, 'M').date(15);
                console.log(ageMthDiff, nextDate);
                let ageMsg = `Please note: Since your pet is less than 8 weeks old, the policy effective date will be ${nextDate.format('MMMM DD, YYYY')} (8 weeks after the 15th of the birth month).`
                notifications(ageMsg, 'Alert', 'warning')
            } else if (ageMthDiff > 96 && type === 'Dog') {
                let ageMsg = 'Oops, Oslo does not start new cover above 8 years old, please contact us at support@osloinsurance.pet for more info'
                notifications(ageMsg, 'Alert', 'error')
                this.setState({ disableBtn: true });
            } else if (ageMthDiff > 120 && type === 'Cat') {
                let ageMsg = 'Oups, Oslo does not start new cover above 10 years old, please contact us at support@osloinsurance.pet for more info'
                notifications(ageMsg, 'Alert', 'error')
                this.setState({ disableBtn: true });
            }
        });
    }

    handlePaste = () => {
        // Wait for pasted content to appear before validating
        setTimeout(() => {
            this.formRef.current?.validateFields(["email"]);
        }, 0);
    };

    render() {
        return (
            <div ref={this.mainRef}>
                <Fragment>
                    {
                        (!this.props.addNewPet && !this.props.renewPolicy) && 
                        <div>
                            <div className="banner home">
                            <Spin spinning={this.props.spinning} tip={this.props.tip} size="large">
                            <img className="img-fluid w-100" src="/images/banner-home.jpg" alt="home-banner"/>
                            
                            <div className="banner-caption">
                                <div className="container">
                                    <Row gutter={15}>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                                            <div className="text-center">
                                                <Title level={1} className="text-green tagline">Unique Pet Insurance</Title>
                                                <Title level={2} className="text-green tagline-sub mt-0 mb-1">In The UAE</Title>
                                                <Title level={4} className="text-green mt-0 mb-5 sub-tagline">Let’s give them the best</Title>
                                                <Button size="large" type="primary" className="btn-red" htmlType="submit" onClick={this.goToQouteSection}>Get a Quote</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            </Spin>
                            {/* <div className="form-get-started">
                                <Row gutter={15} align="middle" justify="center">
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form
                                            layout={"inline"}
                                            name="search"
                                            className="form-pet-search"
                                            size={"large"}
                                            onFinish={(values) => {
                                                this.formRef.current.setFieldsValue({
                                                    name: values.search_pet,
                                                });
                                                this.qouteRef.current.scrollIntoView()
                                            }}
                                        >
                                            <Form.Item
                                                name="search_pet"
                                                rules={[{ required: true, message: 'Please enter your pet name.' }]}
                                            >
                                                <Input placeholder="My Pet’s Name" prefix={<Image className="icon-fomr-gs" preview={false} src="/images/icon-form-GS.png" />} />
                                            </Form.Item>
                                            <Form.Item className="btn-search">
                                                <Button block htmlType="submit" className="btn-dark-green">GET STARTED</Button>
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                            </div> */}
                        </div>
                        <div className="insurance-points full-width text-center pt-5 pb-5" style={{ background: '#B8E5EC' }}>
                            <div className="container">
                                <Title level={2} className="text-green text-center section-title mb-5">OSLO will be by your side</Title>
                                
                                {/* Coverage Banner */}
                                <div className="coverage-banner mb-4" style={{ 
                                    background: 'linear-gradient(135deg, #00ACC1 0%, #00838F 100%)',
                                    borderRadius: '15px',
                                    padding: '20px 30px',
                                    position: 'relative',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
                                }}>
                                    <Row gutter={[20, 20]} align="middle">
                                        <Col xs={24} sm={2} md={2} lg={1} xl={1} className="text-center">
                                            <div style={{ 
                                                width: '50px', 
                                                height: '50px',
                                                background: 'rgba(255,255,255,0.2)',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: '0 auto'
                                            }}>
                                                <i className="fa fa-shield" style={{ fontSize: '24px', color: 'white' }}></i>
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={14} md={14} lg={16} xl={16}>
                                            <div style={{ textAlign: 'left', marginLeft: '15px' }}>
                                                <Title level={4} className="mb-1" style={{ color: 'white', fontWeight: '600', marginBottom: '5px' }}>
                                                    Coverage for Curable Pre-Existing Conditions
                                                    <span style={{ 
                                                        background: '#FFA726', 
                                                        color: 'white', 
                                                        padding: '4px 15px', 
                                                        borderRadius: '22px', 
                                                        fontSize: '16px',
                                                        marginLeft: '10px',
                                                        fontWeight: 'normal',
                                                        display: 'inline-block'
                                                    }}>
                                                        No extra cost 😊
                                                    </span>
                                                </Title>
                                                <Paragraph className="mb-0" style={{ color: 'white', fontSize: '15px', lineHeight: '1.5' }}>
                                                    OSLO provides coverage for curable pre-existing conditions after they've been treatment-free for 12 months, including ear infections, urinary tract infections, and vomiting.
                                                </Paragraph>
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={8} md={8} lg={7} xl={7} className="text-center">
                                            <a href={curablepreexistingconditionspdf} 
                                                size="large"
                                                //onClick={() => window.open('/images/curable-preexisting-conditions-coverage-after-12-months.pdf', '_blank')}
                                                style={{ 
                                                    background: 'white', 
                                                    color: '#00ACC1', 
                                                    border: 'none',
                                                    borderRadius: '25px',
                                                    fontWeight: '600',
                                                    padding: '10px 20px',
                                                    height: '45px',
                                                    cursor: 'pointer'
                                                }}
                                                download 
                                                target="_blank" 
                                                rel="noreferrer"
                                            >
                                                Learn more <i className="fa fa-arrow-right" style={{ marginLeft: '8px' }}></i>
                                            </a>
                                        </Col>
                                    </Row>
                                    <div style={{ 
                                        position: 'absolute', 
                                        top: '-12px', 
                                        right: '30px',
                                        background: '#FF4757',
                                        color: 'white',
                                        padding: '5px 15px',
                                        borderRadius: '15px',
                                        fontSize: '11px',
                                        fontWeight: '700',
                                        letterSpacing: '0.5px',
                                        boxShadow: '0 2px 8px rgba(255,71,87,0.4)'
                                    }}>
                                        NEW
                                    </div>
                                </div>

                                {/* Coverage Cards */}
                                <Row gutter={[20, 20]} justify="center" className="mt-4">
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <Card 
                                            bordered={false}
                                            style={{ 
                                                height: '100%', 
                                                borderRadius: '15px',
                                                boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                                                background: 'white'
                                            }}
                                            bodyStyle={{ padding: '30px 25px' }}
                                        >
                                            <div className="text-center mb-3">
                                                <div style={{ 
                                                    width: '90px', 
                                                    height: '90px', 
                                                    borderRadius: '50%',
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                                }}>
                                                    <Image 
                                                        preview={false}
                                                        src="/images/badge-accident.png"
                                                        width="100%"
                                                        height="100%"
                                                        style={{ objectFit: 'cover' }}
                                                    />
                                                </div>
                                            </div>
                                            <Title level={4} className="text-center text-dark-green mb-3" style={{ fontWeight: '600' }}>
                                                Accidents
                                            </Title>
                                            <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
                                                    <div className="mb-1">Injury</div>
                                                    <div className="mb-1">Sickness</div>
                                                    <div className="mb-1">Broken bones</div>
                                                    <div className="mb-2">Sprains</div>
                                            </div>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <Card 
                                            bordered={false}
                                            style={{ 
                                                height: '100%', 
                                                borderRadius: '15px',
                                                boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                                                background: 'white'
                                            }}
                                            bodyStyle={{ padding: '30px 25px' }}
                                        >
                                            <div className="text-center mb-3">
                                                <div style={{ 
                                                    width: '90px', 
                                                    height: '90px', 
                                                    borderRadius: '50%',
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                                }}>
                                                    <Image 
                                                        preview={false}
                                                        src="/images/badge-illness.png"
                                                        width="100%"
                                                        height="100%"
                                                        style={{ objectFit: 'cover' }}
                                                    />
                                                </div>
                                            </div>
                                            <Title level={4} className="text-center text-dark-green mb-3" style={{ fontWeight: '600' }}>
                                                Illness
                                            </Title>
                                            <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
                                                <div className="mb-1">Vomiting</div>
                                                <div className="mb-1">Diarrhea</div>
                                                <div className="mb-1">Infections</div>
                                                <div className="mb-1">Cancer</div>
                                                <div className="mb-1">Heart disease</div>
                                                <div className="mb-1">Diabetes</div>
                                                <div className="mb-2">Blood & eye disorder</div>
                                                <div className="mt-3" style={{ fontWeight: '600', color: '#333' }}>
                                                    Curable Pre-Existing Conditions
                                                </div>
                                            </div>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <Card 
                                            bordered={false}
                                            style={{ 
                                                height: '100%', 
                                                borderRadius: '15px',
                                                boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                                                background: 'white'
                                            }}
                                            bodyStyle={{ padding: '30px 25px' }}
                                        >
                                            <div className="text-center mb-3">
                                                <div style={{ 
                                                    width: '90px', 
                                                    height: '90px', 
                                                    borderRadius: '50%',
                                                    overflow: 'hidden',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: '0 auto',
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                                }}>
                                                    <Image 
                                                        preview={false}
                                                        src="/images/badge-vet-cost.png"
                                                        width="100%"
                                                        height="100%"
                                                        style={{ objectFit: 'cover' }}
                                                    />
                                                </div>
                                            </div>
                                            <Title level={4} className="text-center text-dark-green mb-3" style={{ fontWeight: '600' }}>
                                                Veterinary
                                            </Title>
                                            <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.8' }}>
                                                <div className="mb-2">Diagnostics</div>
                                                <div className="mb-2">Procedures</div>
                                                <div className="mb-2">Medication</div>
                                                <div className="mb-2">Imaging</div>
                                                <div className="mb-2">Emergency</div>
                                            </div>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="pet-insurance full-width">
                            <div className="container">
                                <Title level={2} className="text-green text-center mb-5 section-title">How does OSLO work?</Title>
                                <Row gutter={[20, 20]}>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <div className="pet-insurance-box text-center">
                                            <Image
                                                preview={false}
                                                className="img-fluid"
                                                src="/images/step1.png"
                                            />
                                            <Title level={3} className="text-green font-700">Take your pet to the vets</Title>
                                            <Paragraph>Seek the best veterinary treatment for your pet when an accident or illness occurs.</Paragraph>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <div className="pet-insurance-box text-center">
                                            <Image
                                                preview={false}
                                                className="img-fluid"
                                                src="/images/step2.png"
                                            />
                                            <Title level={3} className="text-green font-700">Send us your claim</Title>
                                            <Paragraph>Send us a pic of your vet bill and submit it through our OSLO pet cloud.</Paragraph>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <div className="pet-insurance-box text-center">
                                            <Image
                                                preview={false}
                                                className="img-fluid"
                                                src="/images/step3.png"
                                            />
                                            <Title level={3} className="text-green font-700">Get your money back</Title>
                                            <Paragraph>Follow your claim status and get paid by direct transfer.  </Paragraph>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <div className="text-center mt-3">
                                            <Button type="link" className="btn-blue rounded-100" size="large">
                                                <Link to="/pet_insurance">See more</Link>
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="author-section full-width">
                            <Image
                                preview={false}
                                className="img-fluid"
                                src="/images/oslo-family.jpg"
                            />
                            <div className="banner-caption">
                                <div className="container position-relative">
                                    <Title level={2} className="text-green text-center mb-5 section-title">Designed for all pet parents</Title>
                                    <div className="qoute-block">
                                        <Title level={3} className="text-green text-center">
                                            At OSLO, we understand that each cat and dog is unique.
                                            They won’t always act like their breed stereotype but well,
                                            that’s the way it is and we like it that way!
                                        </Title>
                                        <Paragraph className="text-light-green text-right mb-0">Emmanuel I., OSLO Founder</Paragraph>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="insurance-plans full-width home-section bg-gray-light">
                            <div className="container">
                                <Title level={2} className="text-green text-center mb-5 section-title">Our plans</Title>
                                <div className="full-width">
                                    <Row gutter={[15, 15]} align="middle" justify="center">
                                        <Col xs={24} sm={24} md={24} lg={24} xl={20}>
                                            <Row gutter={[15, 15]} align="middle">
                                                {
                                                    this.state.plans.length && this.state.plans.map((obj, index) => (
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <Card className="plan-box">
                                                                <Button className="btn-category btn-blue rounded-100">{obj.title}</Button>

                                                                <div 
                                                                                                className="plan-tagline mt-4" 
                                                                                                style={{ 
                                                                                                    fontSize: '18px',
                                                                                                    wordWrap: 'break-word',
                                                                                                    overflowWrap: 'break-word',
                                                                                                    whiteSpace: 'normal',
                                                                                                    lineHeight: '1.4'
                                                                                                }}
                                                                                            >
                                                                                                <div style={{ marginBottom: '4px' }}>
                                                                                                    AED {(BenifitsMap[obj.annualy].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))} Annual Benefits
                                                                                                </div>
                                                                                            </div>
                                                                <div className="plan-price text-center mt-4 ">
                                                                    <span >from</span>
                                                                </div>
                                                                <div className="plan-price text-center">
                                                                    {/* <sub>{CURRENCY}</sub> <span className="price-amount">{obj.monthly.toString().split(".")[0]}</span> */}
                                                                    
                                                                    <sub>{CURRENCY}</sub> <span className="price-amount">{(index) ? (index == 1) ? 77 : 89 : 50 }</span><sub>/month</sub>
                                                                    {/* <div className="full-width">per month</div> */}
                                                                </div>
                                                                <div className={index > 0 ? "what-we-cover full-width mt-4 text-center" : "what-we-cover full-width mt-5 text-center mb-4"}>
                                                                    <img src="/images/icon-warning-red.png" />
                                                                    <Title level={5} className="text-light-green mt-3">What we cover</Title>
                                                                </div>
                                                                {   
                                                                    index > 0 &&
                                                                    <div className="plan-price text-center mt-4 ">
                                                                        <span >Covered Curable Pre-Existing Conditions</span>
                                                                    </div>
                                                                }
                                                                
                                                            </Card>
                                                        </Col>
                                                    ))
                                                }
                                            </Row>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div className="text-center mt-5">
                                                <Button type="link" className="btn-blue rounded-100" size="large" onClick={this.onDetailClick}>See more</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div className="pet-needs-table-outer full-width" ref={this.pageRef}>
                            <div className="container">
                                <Title level={2} className="text-green text-center mb-4 section-title">The exact coverage level your pet needs</Title>
                                <Row gutter={15} align="middle" justify="center">
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <FeaturesTable />
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <div className="text-center mt-3">
                                            <Button type="link" className="btn-red" size="large" onClick={this.goToQouteSection}>Get a Quote</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="insurance-plans full-width home-section bg-gray-light">
                            <div className="container">
                                <Title level={2} className="text-black text-center mb-3 section-title">Oslo Pet Insurance Featured in</Title>
                                <div className="full-width">
                                    <Row gutter={[15, 15]} align="middle" justify="center" className='mb-5'>
                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                            <img className='full-width' src="/images/logo-gulf-news.svg" />
                                        </Col>
                                    </Row>
                                    <Row gutter={[15, 15]} align="middle" justify="center">
                                        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                                            <Row className='gulf-times-post'>
                                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                    <Badge.Ribbon text="Gulf News Report" color="red" placement="end" className='gulf-times-post-ribbon'>
                                                        <img className='full-width' src="/images/about-us-what-oslo.jpg" />
                                                    </Badge.Ribbon>
                                                </Col>
                                                <Col xs={24} sm={24} md={16} lg={16} xl={16} className='p-5'>
                                                    <Title level={2} className="text-white m-0 p-0">Oslo - The Unique Pet Insurance In the UAE</Title>
                                                    <Title level={3} className="text-white m-0 p-0">- Emmanuel Isenbrandt, Founder</Title>
                                                    <Paragraph className="text-white font-700 my-3">
                                                    “UAE pet parents have had very limited options to choose from until recently.” The local pet population has been rising steadily for the last couple of years which spiked the number of families adopting cats and dogs. It is undoubtedly one of the noblest and a crucial decision to make. Adding a member to the family means taking care of the new member as well as keeping your finances in check....
                                                    </Paragraph>
                                                    <Button type="link" className="btn-red" target='blank' href="https://gulfnews.com/business/corporate-news/oslo-pet-insurance-launched-in-the-uae-1.1684305971086" style={{minWidth:'unset'}}>Read more</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div className="pet-insurance full-width">
                            <div className="container">
                                <Title level={2} className="text-green text-center mb-5 section-title">What real cat parents are saying</Title>
                                <Carousel autoplay autoplaySpeed={7000} dots={{className:'carousel-dots'}}>
                                    <div>
                                        <Row gutter={[20, 20]}>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div className="pet-insurance-box bg-gray-light testimonial" style={{ borderRadius: '10px' }}>
                                                    <div className="testimonial-glyphe">
                                                        <Image
                                                            preview={false}
                                                            className="img-fluid"
                                                            src="/images/testimonial-icon.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <blockquote className="testimonial-quote">
                                                            Quick & efficient from start to finish, no paperwork at all for our pet’s medical claim! Amazing OSLO! Highly recommend to all UAE pet parents!
                                                        </blockquote>
                                                        <div className="red-seperator"></div>
                                                        <div className="testimonial-author">
                                                            <span className="author-name text-green">Fanny G,</span>
                                                            <span className="author-pet text-green">Pet Parent to Duchesse</span>
                                                        </div>
                                                    </div>
                                                    <div className="testimonial-image-holder">
                                                        <div className="testimonial-image">
                                                            <Image
                                                                preview={false}
                                                                className="img-fluid"
                                                                src="/images/duchesse-testimonial.svg"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div className="pet-insurance-box bg-gray-light testimonial" style={{ borderRadius: '10px' }}>
                                                    <div className="testimonial-glyphe">
                                                        <Image
                                                            preview={false}
                                                            className="img-fluid"
                                                            src="/images/testimonial-icon.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <blockquote className="testimonial-quote">
                                                            Oslo pet insurance is super easy to apply and even simpler and easier to understand. Love it!
                                                        </blockquote>
                                                        <div className="red-seperator"></div>
                                                        <div className="testimonial-author">
                                                            <span className="author-name text-green">Stephanie,</span>
                                                            <span className="author-pet text-green">Cat parent to July</span>
                                                        </div>
                                                    </div>
                                                    <div className="testimonial-image-holder">
                                                        <div className="testimonial-image">
                                                            <Image
                                                                preview={false}
                                                                className="img-fluid"
                                                                src="/images/july-testimonial.svg"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>       
                                    </div>
                                    <div>
                                        <Row gutter={[20, 20]}>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div className="pet-insurance-box bg-gray-light testimonial" style={{ borderRadius: '10px' }}>
                                                    <div className="testimonial-glyphe">
                                                        <Image
                                                            preview={false}
                                                            className="img-fluid"
                                                            src="/images/testimonial-icon.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <blockquote className="testimonial-quote">
                                                            Pet insurance was really confusing and hard to understand until we found Oslo. The vet bills are not going to be a worry anymore. No financial stress also. Thanks to Oslo pet insurance.
                                                        </blockquote>
                                                        <div className="red-seperator"></div>
                                                        <div className="testimonial-author">
                                                            <span className="author-name text-green">Chole & Tia</span>
                                                        </div>
                                                    </div>
                                                    <div className="testimonial-image-holder">
                                                        <div className="testimonial-image">
                                                            <Image
                                                                preview={false}
                                                                className="img-fluid"
                                                                src="/images/chole-tia-testimonial.svg"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div className="pet-insurance-box bg-gray-light testimonial" style={{ borderRadius: '10px' }}>
                                                    <div className="testimonial-glyphe">
                                                        <Image
                                                            preview={false}
                                                            className="img-fluid"
                                                            src="/images/testimonial-icon.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <blockquote className="testimonial-quote">
                                                        Super happy with Oslo. Great to finally have an insurance for my dog Lilly which is not too expensive and reimburse pretty much everything - Well done Oslo!
                                                        </blockquote>
                                                        <div className="red-seperator"></div>
                                                        <div className="testimonial-author">
                                                            <span className="author-name text-green">Chris Delorme</span>
                                                        </div>
                                                    </div>
                                                    <div className="testimonial-image-holder">
                                                        <div className="testimonial-image">
                                                            <Image
                                                                preview={false}
                                                                className="img-fluid"
                                                                src="/images/chris-delorme-testimonial.svg"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Carousel>
                            </div>
                        </div>
                        <div className="insurance-points full-width faqs-content">
                            <div className="container">
                                <Title level={2} className="text-green text-center section-title">Any Question, We got you covered.</Title>
                                {
                                    this.state.faqItems &&
                                    <Row gutter={15} justify="left">
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Collapse className="points-toknow" bordered={false} expandIconPosition={"right"}>
                                            {
                                                this.state.faqItems.map((faqItem, index) => {
                                                    return (
                                                        <Panel header={<Title level={3} className="m-0 text-green font-700">{faqItem.question}</Title>} key={index}>
                                                            <Paragraph className="text-green">{faqItem.answer}</Paragraph>
                                                            {
                                                                faqItem.hasChildItems && 

                                                                <ul>
                                                                {
                                                                    faqItem.childItems.map((childItem, indexChild) => {
                                                                        return (
                                                                            <li>{childItem.text}</li>
                                                                        )
                                                                    })
                                                                }
                                                                </ul>
                                                            }
                                                            
                                                        </Panel>
                                                    )
                                                })
                                            } 
                                                
                                                
                                            </Collapse>
                                        </Col>
                                    </Row>
                                }
                                
                                <div className="text-center mt-4">
                                    <Button className="btn-white rounded-100" size="large">
                                        <Link to="/faqs">Learn more</Link>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    
                    <div className="customise-paln bg-gray-light pt-5 pb-5 full-width" ref={this.qouteRef}>
                        <div className="container">
                            <Title level={2} className="text-green text-center section-title mb-5">Let’s build our new mate’s plan </Title>
                            <Row gutter={15} align="middle" justify="center">
                                <Col xs={24} sm={24} md={24} lg={18} xl={13}>
                                    <Row gutter={15} align="middle" className="full-width">
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form
                                                name="basic"
                                                onFinish={this.onFinish}
                                                onFinishFailed={this.onFinishFailed}
                                                size={"large"}
                                                className="customise-form"
                                                ref={this.formRef}
                                            >
                                                <Form.Item
                                                    name="name"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Please input pet's name!",
                                                        },
                                                    ]}
                                                >
                                                    <Input placeholder={"My Pet’s Name *"} />
                                                </Form.Item>
                                                <Row gutter={15} justify="center">
                                                    {!this.state.spin && <Col sm={12} md={12} lg={12} xl={12}>

                                                        <Spin spinning={this.state.spin}>
                                                            <Form.Item
                                                                className="text-center"
                                                                name="type"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: 'Please select type! *',
                                                                    }
                                                                ]}
                                                                initialValue={this.state.dogId}
                                                                onChange={this.onTypeChange}
                                                            >

                                                                {
                                                                    this.state.petTypeBreeds.length && <Radio.Group buttonStyle="solid" className={`btn-sliding` + ' ' + this.state.petBtnClass} onChange={this.changeType}>
                                                                        {
                                                                            this.state.petTypeBreeds.map((type, index) =>
                                                                                <Radio.Button key={index} value={type.id} id={index} petType={type.name}>{type.name}</Radio.Button>
                                                                            )
                                                                        }
                                                                        {/* <Radio.Button value="cat">Cat</Radio.Button> */}
                                                                        <span className="switch-selection"></span>
                                                                    </Radio.Group>
                                                                }
                                                            </Form.Item>
                                                        </Spin>
                                                    </Col>}
                                                    <Col sm={12} md={12} lg={12} xl={12} className={this.state.genderBtnType}>
                                                        {/* value='Male' initialValue={'Male'} */}
                                                        <Form.Item className="text-center" name="gender"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please select gender! *',
                                                                },
                                                            ]}
                                                            initialValue={"Male"}
                                                            onChange={this.onGenderChange}>
                                                            <Radio.Group buttonStyle="solid" className={`btn-sliding` + ' ' + this.state.genderBtnType.toLowerCase()}>
                                                                <Radio.Button value="Male">Male</Radio.Button>
                                                                <Radio.Button value="Female">Female</Radio.Button>
                                                                <span className="switch-selection"></span>
                                                            </Radio.Group>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Form.Item
                                                    name="age"
                                                    size={"large"}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Select Date of Birth (MM/YYYY)! *',
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker onChange={this.ageChange} style={{ width: '100%' }} placeholder="Select Date of Birth (MM/YYYY) *" format="MM/YYYY" picker="month" disabledDate={(current) => current && current > moment().endOf('day')} />
                                                </Form.Item>
                                                    <div className="features-table" style={{position:"relative"}}>
                                                        <span className="icon-info breed-info">
                                                            <Tooltip overlayClassName="tooltip-blue" color={'#57C6D6'} placement="right" title={<div className="tooltip-content">If your pet is not a pure breed please select “Crossbreed” </div>}>
                                                                <i className="fa fa-info-circle"></i>
                                                            </Tooltip>
                                                        </span>
                                                    </div>
                                                    <Form.Item
                                                        name="breed"
                                                        size={"large"}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please select breed! *',
                                                            },
                                                        ]}
                                                    >
                                                        <Select placeholder="Select breed *"
                                                            showSearch
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            filterSort={(optionA, optionB) =>
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                                            }
                                                        >
                                                            {
                                                                this.state.petBreeds && (this.state.petBreeds.map((breed, index) =>
                                                                    <Option key={index} value={breed.id}>{breed.name}</Option>
                                                                ))
                                                            }
                                                        </Select>
                                                    </Form.Item>
                                                {
                                                !this.props.addNewPet &&            
                                                <Form.Item
                                                    name="email"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please input your email! *',
                                                        },
                                                        {
                                                            type: 'email',
                                                            message: 'Please input correct email! ',
                                                        },
                                                        {
                                                            validator: (_, value) => {
                                                                if (value && value.trim() !== value) {
                                                                    return Promise.reject(new Error('Email should not have leading or trailing spaces!'));
                                                                }
                                                                if (value && /[A-Z]/.test(value)) {
                                                                    return Promise.reject(new Error('Email should be in lowercase!'));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder="Email *"
                                                        value={this.state.email}
                                                        onKeyDown={(e) => {
                                                            if (e.key === " " || e.getModifierState("CapsLock")) {
                                                                e.preventDefault(); // Prevent spaces and Caps Lock
                                                            }
                                                        }}
                                                        onKeyUp={(e) => {
                                                            if (e.key === " " || e.getModifierState("CapsLock")) {
                                                                e.preventDefault(); // Prevent spaces and Caps Lock
                                                            }
                                                        }}
                                                        onKeyPress={(e) => {
                                                            if (e.key === " " || e.getModifierState("CapsLock")) {
                                                                e.preventDefault(); // Prevent spaces and Caps Lock
                                                            }
                                                        }}
                                                        // onPaste={this.handlePaste}
                                                    />
                                                    {/* <Input placeholder="Email *" value={this.state.email} onChange={this.handleEmailChange}/> */}
                                                </Form.Item>
                                                }
                                                {/* <Form.Item
                                                    name="promo"
                                                >
                                                    <Input placeholder="Promo Code" />
                                                </Form.Item> */}
                                                <Form.Item className="text-center mt-5">
                                                    <Button disabled={this.state.disableBtn} type="primary" className="btn-red rounded-100" htmlType="submit">Continue</Button>
                                                </Form.Item>
                                            </Form>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Fragment>
            </div>
        );
    }
}

export default MainPage;